import { render, staticRenderFns } from "./MovingArrow.vue?vue&type=template&id=fccf9be0"
import script from "./MovingArrow.vue?vue&type=script&lang=js"
export * from "./MovingArrow.vue?vue&type=script&lang=js"
import style0 from "./MovingArrow.vue?vue&type=style&index=0&id=fccf9be0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports